// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"UserAccess_ProseMirror__3zxW4","userAccess__error":"UserAccess_userAccess__error__2EqEJ"};